/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PetV2PrimaryDisciplineModel
 */
export interface PetV2PrimaryDisciplineModel {
    /**
     * 
     * @type {number}
     * @memberof PetV2PrimaryDisciplineModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PetV2PrimaryDisciplineModel
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof PetV2PrimaryDisciplineModel
     */
    groupName?: string;
}

/**
 * Check if a given object implements the PetV2PrimaryDisciplineModel interface.
 */
export function instanceOfPetV2PrimaryDisciplineModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetV2PrimaryDisciplineModelFromJSON(json: any): PetV2PrimaryDisciplineModel {
    return PetV2PrimaryDisciplineModelFromJSONTyped(json, false);
}

export function PetV2PrimaryDisciplineModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetV2PrimaryDisciplineModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'groupName': !exists(json, 'groupName') ? undefined : json['groupName'],
    };
}

export function PetV2PrimaryDisciplineModelToJSON(value?: PetV2PrimaryDisciplineModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'groupName': value.groupName,
    };
}

